import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import {
  reducer as cadViewerReducer,
  saga as cadViewerSaga,
} from './cadViewer/index';
import viewerReducer from './data/reducer';
import viewerSaga from './data/sagas';
import dxfViewerReducer from './dxfViewer/data/reducer';
import pdfViewerReducer from './pdfViewer/data/reducer';
import pdfViewerSaga from './pdfViewer/data/sagas';

export const reducer = combineReducers({
  cadViewer: cadViewerReducer,
  pdfViewer: pdfViewerReducer,
  dxfViewer: dxfViewerReducer,
  viewer: viewerReducer,
});

export const saga = function* () {
  yield all([cadViewerSaga(), pdfViewerSaga(), viewerSaga()]);
};
